import React from "react";
import { Instagram } from "lucide-react";
import { ASSETS } from "../data/menu";

const quickLinks = [
  { label: "About", href: "#about" },
  { label: "Categories", href: "#categories" },
  { label: "Menu", href: "#menu" },
  { label: "Signature", href: "#signature" },
  { label: "Gallery", href: "#gallery" },
  { label: "Visit Us", href: "#visit" },
];

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-espresso text-cream pt-20 pb-10"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid md:grid-cols-12 gap-10 md:gap-16">
        <div className="md:col-span-5">
          <div className="relative h-32 w-80 overflow-hidden">
            <img
              src={ASSETS.logo}
              alt="OROMA — your daily ritual"
              className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 h-[240%] w-auto object-contain"
              style={{ mixBlendMode: "lighten", filter: "invert(1)" }}
              data-testid="footer-logo"
            />
          </div>
          <p className="mt-5 font-script text-2xl text-gold">your daily ritual</p>
          <p className="mt-8 max-w-md text-cream/70 leading-[1.85] text-[14px]">
            A modern café experience in the heart of Mumbai. Brewed slow,
            plated thoughtfully, and made for people who appreciate good taste
            and good moments.
          </p>
        </div>

        <div className="md:col-span-3">
          <p className="text-[12px] tracking-[0.3em] uppercase text-gold mb-5">
            Quick Links
          </p>
          <ul className="space-y-3">
            {quickLinks.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  data-testid={`footer-link-${l.label.toLowerCase().replace(" ", "-")}`}
                  className="link-underline text-cream/80 hover:text-cream text-[14px]"
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="text-[12px] tracking-[0.3em] uppercase text-gold mb-5">
            Find Us
          </p>
          <p className="text-cream/80 text-[14px] leading-[1.85]" data-testid="footer-address">
            Shop No 5, Cornelian Building 104,
            <br />
            August Kranti Marg, Kemps Corner,
            <br />
            Mumbai 400036, Maharashtra, India
          </p>

          <a
            href="https://www.instagram.com/oroma_bombay"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-instagram-link"
            className="mt-6 inline-flex items-center gap-3 text-cream hover:text-gold transition-colors duration-500"
          >
            <span className="w-10 h-10 rounded-full border border-cream/30 flex items-center justify-center">
              <Instagram size={16} />
            </span>
            <span className="text-[13px] tracking-[0.2em] uppercase">
              @oroma_bombay
            </span>
          </a>
        </div>
      </div>

      <div className="max-w-[1400px] mx-auto px-6 md:px-10 mt-16 pt-8 border-t border-cream/15 flex flex-col md:flex-row items-center justify-between gap-4">
        <p className="text-cream/60 text-[12px] tracking-[0.18em] uppercase">
          © {new Date().getFullYear()} OROMA Café · Mumbai
        </p>
        <p className="font-script text-2xl text-gold">
          Designed with warmth & coffee.
        </p>
      </div>
    </footer>
  );
};
